<template>
    <div>
        <div class="form-group row">
            <label for="upload_logo_file" class="col-md-3 col-form-label">{{ $t('words.logo') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.channel.logo_tip_1')}}<br>
                    {{ $t('paragraphs.channel.logo_tip_2', { maxWidth: logo.maxWidth, maxHeight: logo.maxHeight } ) }}
                </p>

                <div class="input-group">
                    <input type="file" ref="logo" accept=".gif,.png" id="upload_logo_file"
                           :class="{ 'form-control': true, 'is-invalid': logo.meta.errors.upload_file }"
                           :readonly="logo.isUploading" v-if="haveSubmitRight"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-primary" v-if="haveSubmitRight" @click="doUploadLogo()"><i class="icon icon-upload"></i>{{ $t('words.upload') }}</button>
                    </div>

                    <div class="invalid-feedback" v-for="error in logo.meta.errors.upload_file" :key="error">{{ error }}</div>
                </div>

                <div class="progress" style="margin-top: 1em;" v-if="logo.isUploading">
                    <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                         :style="{ width: `${logo.progressValueNow}%` }" :aria-valuenow="logo.progressValueNow">
                        {{ logo.progressValueNow > 0 ? `${logo.progressValueNow}%` : ''}}
                    </div>
                </div>

                <div v-if="channel.logo_url !== ''" class="thumbnailbox" >
                    <img :src="channel.logo_url" class="img-thumbnail" style="max-width:100px;max-height:100px;"/>
                    <button class="btn btn-icon btn-close" v-if="haveSubmitRight" @click="doRemoveLogo()"><i class="icon icon-close"></i></button>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-3">{{ $t('words.idle_screen_kind') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.channel.idle_screen_kind_tip_1') }}<br>
                    {{ $t('paragraphs.channel.idle_screen_kind_tip_2') }}
                </p>
                <div class="form-redio">
                    <label>
                        <input type="radio" value="0" :disabled="!haveSubmitRight" v-model="channel.idle_screen_kind" @change="onUpdateIdleScreenKind">
                    {{ $t('paragraphs.channel.idle_screen_kind.use_poster') }}</label>
                </div>
                <div class="form-redio">
                    <label>
                        <input type="radio" value="1" :disabled="!haveSubmitRight || !snapshotAvailable" v-model="channel.idle_screen_kind" @change="onUpdateIdleScreenKind">
                        {{ $t('paragraphs.channel.idle_screen_kind.use_snapshot') }}</label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="upload_poster_file" class="col-md-3">{{ $t('words.poster') }}</label>
            <div class="col-md-9">
                <p class="text-guide">
                    {{ $t('paragraphs.channel.poster_tip_1') }}<br>
                    {{ $t('paragraphs.channel.poster_tip_2', { maxWidth: poster.maxWidth, maxHeight: poster.maxHeight } ) }}
                </p>
                <div class="input-group">
                    <input type="file" ref="poster" accept=".gif,.png" id="upload_poster_file"
                           :class="{ 'form-control': true, 'is-invalid': poster.meta.errors.upload_file }"
                           :readonly="poster.isUploading" v-if="haveSubmitRight"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-primary" v-if="haveSubmitRight" @click="doUploadPoster()"><i class="icon icon-upload"></i>{{ $t('words.upload') }}</button>
                    </div>

                    <div class="invalid-feedback" v-for="error in poster.meta.errors.upload_file" :key="error">{{ error }}</div>
                </div>

                <div class="progress" style="margin-top: 1em;" v-if="poster.isUploading">
                    <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                         :style="{ width: `${poster.progressValueNow}%` }" :aria-valuenow="poster.progressValueNow">
                        {{ poster.progressValueNow > 0 ? `${poster.progressValueNow}%` : ''}}
                    </div>
                </div>

                <div v-if="channel.poster_url !== ''" class="thumbnailbox" >
                    <img :src="channel.poster_url" class="img-thumbnail" />
                    <button class="btn btn-icon btn-close" v-if="haveSubmitRight" @click="doRemovePoster()"><i class="icon icon-close"></i></button>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="snapshot_uri" class="col-md-3">{{ $t('words.snapshot') }}</label>
            <div class="col-md-9">
                <div  v-if="snapshotAvailable">
                    <p class="text-guide">
                        {{ $t('paragraphs.channel.snapshot_tip_1') }}<br>
                        {{ $t('paragraphs.channel.snapshot_tip_2') }}
                    </p>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('words.link') }}</span>
                        </div>
                        <input type="text" name="snapshot_uri" placeholder="" class="form-control" id="snapshot_uri" v-model="channel.snapshot_url" disabled />
                        <div class="input-group-append">
                            <button class="btn btn-outline-info clipboard-copy" v-clipboard:copy="channel.snapshot_url" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">{{ $t('words.copy') }}</button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ $t('paragraphs.not_use_policy')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'decoration',
            poster: {
                progressValueNow: 0,
                isUploading: false,
                maxWidth: 1200,
                maxHeight: 900,
                meta: {
                    errors: {},
                },
            },
            logo: {
                progressValueNow: 0,
                isUploading: false,
                maxWidth: 120,
                maxHeight: 60,
                meta: {
                    errors: {},
                },
            },
        };
    },
    methods: {
        initialDatas() {
            this.$refs.poster.value = null;
            this.$refs.logo.value = null;
            this.poster.meta.errors = {};
            this.logo.meta.errors = {};
        },
        /**
         * doCopy
         *
         * @param {string} copyText
         * @return {void}
         */
        doCopy(copyText) {
            this.$copyText(copyText).then(() => {
                this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
            });
        },
        onCopy(e) {
            this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
        },
        onCopyError(e) {
            console.log(e);
        },
        /**
         * doUploadPoster
         *
         * @return {void}
         */
        doUploadPoster() {
            if (!this.haveSubmitRight) {
                return;
            }

            const formData = new FormData();
            const file = this.$refs.poster.files[0];

            if (typeof file === 'undefined') {
                this.$toasted.error(this.$t('paragraphs.please_select_file'));
                return;
            }

            this.poster.meta.errors = {};
            this.poster.isUploading = true;
            formData.append('upload_file', file);

            axios.post(`${this.channelApiPath}/poster`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (event) => {
                    const totalLength = event.lengthComputable
                        ? event.total
                        : event.target.getResponseHeader('content-length')
                        || event.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength != null) {
                        this.poster.progressValueNow = _.round((event.loaded * 100) / event.total);
                    }
                },
            }).then((response) => {
                this.channel.poster_url = response.data.poster_url;
                this.$toasted.success(this.$t('paragraphs.message.success.upload'));
                this.$refs.poster.value = null;
                this.poster.meta.errors = {};
                setTimeout(() => {
                    this.poster.isUploading = false;
                }, 2000);
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.upload'));
                this.poster.meta.errors = error.response.data.errors;
                setTimeout(() => {
                    this.poster.isUploading = false;
                }, 2000);
            });
        },
        doUploadLogo() {
            if (!this.haveSubmitRight) {
                return;
            }

            const formData = new FormData();
            const file = this.$refs.logo.files[0];

            if (typeof file === 'undefined') {
                this.$toasted.error(this.$t('paragraphs.please_select_file'));
                return;
            }

            this.logo.meta.errors = {};
            this.logo.isUploading = true;
            formData.append('upload_file', file);

            axios.post(`${this.channelApiPath}/logo`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (event) => {
                    const totalLength = event.lengthComputable
                        ? event.total
                        : event.target.getResponseHeader('content-length')
                        || event.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength != null) {
                        this.logo.progressValueNow = _.round((event.loaded * 100) / event.total);
                    }
                },
            }).then((response) => {
                this.channel.logo_url = response.data.logo_url;
                this.$toasted.success(this.$t('paragraphs.message.success.upload'));
                this.$refs.logo.value = null;
                this.logo.meta.errors = {};
                setTimeout(() => {
                    this.logo.isUploading = false;
                }, 2000);
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.upload'));
                this.logo.meta.errors = error.response.data.errors;
                setTimeout(() => {
                    this.logo.isUploading = false;
                }, 2000);
            });
        },
        doRemovePoster() {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`${this.channelApiPath}/poster`).then((response) => {
                    this.channel.poster_url = '';
                    this.$toasted.success(this.$t('paragraphs.message.success.remove'));
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_file'));
                });
            }

            return;
        },
        doRemoveLogo() {
            if (!this.haveSubmitRight) {
                return;
            }

            axios.delete(`${this.channelApiPath}/logo`).then((response) => {
                this.channel.logo_url = response.data.logo_url;
                this.$toasted.success(this.$t('paragraphs.message.success.remove'));
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.remove_file'));
            });
        },
        onUpdateIdleScreenKind() {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.are_you_sure_that_update_this'))) {
                axios.patch(`${this.channelApiPath}`, {
                    idle_screen_kind: this.channel.idle_screen_kind,
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.update'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                });
            }
        },
    },
    computed: {
        channelApiPath() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialDatas();
            }
        },
    },
};

</script>
<style>
</style>
